var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container",style:({padding:'25px 0'})},[_c('Bread'),_c('SecondNav'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }